import request from '../untils/request';

export const appVersionListApi = params => {
  return request({
    url: '/system/app-version/list',
    authCode: 'APP-VERSSION',
    params,
  });
};

export const appVersionSaveApi = params => {
  return request({
    url: '/system/app-version/update',
    authCode: 'APP-VERSSION',
    params,
  });
};
export const appVersionUpdateStatusApi = params => {
  return request({
    url: '/system/app-version/update-status',
    authCode: 'APP-VERSSION',
    params,
  });
};
export const appVersionUpdateGrayApi = params => {
  return request({
    url: '/system/app-version/update-gray',
    authCode: 'APP-VERSSION',
    params,
  });
};


